/**
 * Wesog user params.
 * @type {{
 *  USERNAME: string,
 *  ACCESS_TOKEN: string,
 *  SEARCHER_HISTORY: string,
 *  LAST_NAME: string,
 *  EMAIL: string,
 *  ID: string,
 *  LANGUAGE: string,
 *  PHONE: string,
 *  PSEUDO: string,
 *  LIGHTBOX: string
 *  EXPIRES_IN: string
 *  CART_UIDS: string
 *  CART_ID: string
 * }}
 */
export const WESOG_USER_PARAMS = {
    USERNAME: 'username',
    ACCESS_TOKEN: 'access_token',
    SEARCHER_HISTORY: 'searcherHistory',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
    ID: 'id',
    LANGUAGE: 'language',
    PHONE: 'phone',
    PSEUDO: 'pseudo',
    LIGHTBOX: 'lightbox',
    EXPIRES_IN: 'expires_in',
    CART_UIDS: 'cart_uids',
    CART_ID: 'cart_id',
};

/**
 * Wesog user actions. Change user process.
 * @type {string}
 */
export const CHANGE_USER_PROCESS = 'CHANGE_USER_PROCESS';

/**
 * Free pass username.
 * @type {string}
 */
export const FREE_PASS_USERNAME = 'FREEPASS';
